function getPercent(value: number, maxValue: number): number {
  if (maxValue <= 0) {
    return 0;
  }

  return Math.min(100, Math.round((value * 100) / maxValue));
}

function getValueFromPercent(percent: number, maxValue: number): number {
  return Math.ceil((percent * maxValue) / 100);
}

export default {
  getPercent,
  getValueFromPercent,
};
